import React, { useState, useEffect } from "react";

const WalletUsageSetting = ({ gstData, setGstData, handleGstSubmit }) => {
    const [percentage, setGstPercent] = useState("");

    useEffect(() => {
        if (gstData?.percentage) {
            setGstPercent(gstData.percentage);
        }
    }, [gstData]);

    const handleChange = (e) => {
        setGstPercent(e.target.value);
    };

    const handleSave = () => {
        if (percentage >= 99) return alert("You can give usage below 99");
        handleGstSubmit({ ...gstData, percentage });
    };

    return (
        <div className="gst-setting-container">
            <label className="gst-setting-label">Percentage (%)</label>
            <div className="gst-setting-inline">
                <input
                    type="number"
                    className="gst-setting-input"
                    value={percentage}
                    onChange={handleChange}
                    placeholder="Enter Usage Percentage %"
                />
                <button className="gst-setting-save-btn" onClick={handleSave}>
                    Save
                </button>
            </div>
        </div>
    );
};

export default WalletUsageSetting;
